import React, { useState, useEffect, useContext } from "react";
import ReactQuillEditor from "../../../components/reactQuillEditor";
import { Button } from "@material-ui/core";
import { PayLoadCtx } from "../../../lib/context";
import { createPatinetMedicalHistory, getPatinetMedicalHistory, updatePatinetMedicalHistory } from "../../../actions/configuration";
import { toast } from "react-toastify";
import PatientHistoryDetails from "./patientHistoryDetails";
import { API } from "aws-amplify";

const PatientHistory = ({ close, data, role }) => {
    const { payload } = useContext(PayLoadCtx);
    const [history, SetHistory] = useState({
        id: "",
        history: "",
        get: false,
    });
    const [loading, setLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);

    const handleget = () => {
        setLoading(true);
        const query = `?did=${data?.doctorId}&aid=${data?.appointmentId}`;
        getPatinetMedicalHistory(query)
            .then((res) => {
                if (res?.status && res?.data) {
                    SetHistory({
                        id: res?.data?._id,
                        history: res?.data?.medicalHistory || "",
                    });
                }
                setHasFetched(true);
                setLoading(false);
            })
            .catch((e) => {
                console.error("Error fetching patient history:", e);
                if (API.isCancel(e)) {
                    console.log("API call canceled.");
                }
                setHasFetched(true);
                setLoading(false);
            });
    };

    useEffect(() => {
        // Reset history when patient data changes
        SetHistory({
            id: "",
            history: "",
            get: false,
        });

        if (!hasFetched) {
            handleget();
        }
    }, [data, hasFetched]);

    const handleSubmitData = async (reset) => {
        setLoading(true);
        if (history?.id === "") {
            let createbody = {
                doctorId: data?.doctorId,
                appointmentId: data?.appointmentId,
                clinicId: data?.clinicId,
                patientId: data?.patientId,
                subdomain: payload?.subdomain,
            };
            if (history?.history && history?.history !== "") {
                createbody["medicalHistory"] = history?.history;
            }
            if (reset === "reset") {
                createbody["medicalHistory"] = "<p></p>";
            }
            createPatinetMedicalHistory(createbody)
                .then((res) => {
                    if (res?.status) {
                        toast.success(res?.data, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        SetHistory({
                            id: res?.data?.id || "", // Assume API response contains `id`
                            history: createbody.medicalHistory,
                            get: true,
                        });
                    } else {
                        toast.error(res?.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    console.log("e.........:", e);
                    setLoading(false);
                });
        } else {
            if (history?.id) {
                let updatebody = {
                    id: history?.id,
                };

                if (history?.history) {
                    updatebody["medicalHistory"] = history?.history;
                }
                if (reset === "reset") {
                    updatebody["medicalHistory"] = "<p></p>";
                }

                try {
                    const res = await updatePatinetMedicalHistory(updatebody);
                    if (res?.status) {
                        toast.success(res?.data, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        SetHistory({ ...history, get: true });
                    } else {
                        toast.error(res?.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                } catch (e) {
                    console.error("Error updating patient history:", e);
                } finally {
                    setLoading(false);
                }
            } else {
                toast.error("No history found to update.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoading(false);
            }
        }
    };

    const handleTerms = (value) => {
        SetHistory({ ...history, history: value });
    };

    return (
        <div className="internalNoteSlider internalNoteSliderIn">
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>Patient History</span>
                    </div>
                    <div className="hdrActionGroup" onClick={close}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
            </div>
            <div className="flexMinheightCol scrollY">
                <PatientHistoryDetails data={data} />
            </div>
        </div>
    );
};

export default PatientHistory;

